import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetNtxPeoplesList } from '@store/NTX/Peoples/peoplesSlice';
import { GetEquipmentsModelList } from '@store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import { GetEngineStatues } from '@store/Lookup/lookupSlice';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { useFormik } from 'formik';
import Select from 'react-select';

import { GetEquipmentsById, GetEquipmentsList, UpdateEquipments } from '@store/FLEET/Equipments/equipmentsSlice';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { CardBody } from '@components/card/card';
import { EquipmentsSchema } from '../../ValidationForm/validationSchema';
// import FileList from '../../Attachments/FileList';
import Loading from '@components/Shared/Loader/Loading';
import useGetColumnByTableId from '@hooks/Forms/useGetColumnByTableId';
import ExtraInformationBuilderUpdate from '../../ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
import ExtraInformationBuilderAdd from '../../ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd';
import useAddUpdateExtraInformation from '../../ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation';
import useLookupEquipmentStatus from '@hooks/Lookups/use-Lookup-EquipmentStatus';
import FileUpload from '@components/Files/FileUpload';
// import useGetDriversList from '@hooks/FLeet/useGetDriversList';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import confirmAction from '@components/Shared/Alert/confirmAction';

const EditEquipments = ({ Id }: { Id: string }) => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [img, setImage] = useState<any[]>([]);
  const [extraInfoFormData, setExtraInfoFormData] = useState<any>({});
  const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();

  // const { OptionsDrivers, loading: loading1, error: error1 } = useGetDriversList();

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
    dispatch(GetEquipmentsModelList());
    dispatch(GetEngineStatues());
    if (Id) {
      dispatch(GetEquipmentsById(Id));
    }
  }, [Id, dispatch]);

  const { EquipmentsById: data, loadingById, errorById } = useAppSelector(state => state.Equipments);
  const { PeoplesList, loading: loading2, error: error2 } = useAppSelector(state => state.Peoples);
  const { EquipmentsModelList, loading: loading3, error: error3 } = useAppSelector(state => state.EquipmentsModel);
  // const { EngineStatues } = useAppSelector(state => state.Lookup);
  const { Organizations, loading: loading4, error: error4, OrganizationOptions } = useGetOrganizations();
  const { EquipmentStatusOptions, loading: loading5, error: error5 } = useLookupEquipmentStatus();
  // console.log(Organizations);
  //__________ جلب حقول المعلومات الإضافية ان وجدت __________
  const TableId = '85d9908f-3d3f-45fc-ac73-4b72164a3f65'; // جدول معدات الأسطول id
  const { FormColumnByTableIdList, loading } = useGetColumnByTableId(TableId);
  //_________________________________________________________

  useEffect(() => {
    if (data?.image) {
      setImage([{ name: data?.image?.fileName, url: data?.image?.filePath }]);
    }
  }, [data]);

  // console.log(data);

  const formik = useFormik({
    initialValues: {
      id: data ? data.id : '',
      name: data ? data.name : '',
      name2: data ? data.name2 : '',
      ExtraInformationId: data ? data.extraInformationId : null,
      description: data ? data.description : '',
      fleetModelId: data ? data.fleetModelId : '',
      plateNo: data ? data.plateNo : '',
      serialNo: data ? data.serialNo : '',
      chassisNo: data ? data.chassisNo : '',
      engineStatus: data ? data.engineStatus : '',
      code: data ? data.code : '',
      barcode: data ? data.barcode : '',
      odometer: data ? data.odometer : '',
      organizationId: data ? data.organizationId : '',
      serviceDate: data ? data.serviceDate?.split('T')[0] : '',
      dateOfExpiry: data ? data.dateOfExpiry?.split('T')[0] : '',
      purchasePrice: data ? data.purchasePrice : '',
      ownerId: data ? data.ownerId : '',
      lastmaintenanceDate: data ? data.lastmaintenanceDate?.split('T')[0] : '',
      driverId: data ? data.driverId : '',
      Status: data ? data.status : '',
      Img: '',
      IsUpdateIMG: false
    },

    enableReinitialize: true,
    validationSchema: EquipmentsSchema(t),
    onSubmit: async values => {
      const msg =
        i18n.language === 'en' ? 'Are you sure you want to proceed with the update?' : 'هل أنت متأكد من عملية التعديـل';

      const confrrm = await confirmAction(msg);
      if (!confrrm) {
        return;
      }

      const formData = new FormData();
      formData.append('Id', values.id || '');
      formData.append('Name', values.plateNo || '');
      formData.append('Name2', values.plateNo || '');
      formData.append('Status', values.Status || '');
      formData.append('Description', values.description || '');
      formData.append('FleetModelId', values.fleetModelId || '');
      formData.append('PlateNo', values.plateNo || '');
      formData.append('SerialNo', values.serialNo || '');
      formData.append('ChassisNo', values.chassisNo || '');
      formData.append('EngineStatus', values.engineStatus || '');
      formData.append('Code', values.code || '');
      formData.append('Barcode', values.barcode || '');
      formData.append('Odometer', values.odometer ? values.odometer.toString() : '');
      formData.append('OrganizationId', values.organizationId || '');
      formData.append('ServiceDate', values.serviceDate || '');
      formData.append('DateOfExpiry', values.dateOfExpiry || '');
      formData.append('PurchasePrice', values.purchasePrice ? values.purchasePrice.toString() : '');
      formData.append('OwnerId', values.ownerId || '');
      formData.append('LastmaintenanceDate', values.lastmaintenanceDate || '');
      formData.append('Img', values.Img);
      formData.append('IsUpdateIMG', values.IsUpdateIMG.toString());

      let respons: any;
      if (extraInfoFormData?.values?.length > 0) {
        respons = await AddUpdateExtraInformation(extraInfoFormData);
      }
      // debugger;
      if (respons === null) {
        CustomAlert({ action: 'Error' });
        return;
      }
      formData.append('ExtraInformationId', respons || '');

      dispatch(UpdateEquipments(formData))
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            // Navigate('/FLEET/Equipments', { replace: true });
            document.getElementById('closeModal22')?.click();
            dispatch(GetEquipmentsList());
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const handleImageUpload: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setImage(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('Img', newAttachments[0]);
        formik.setFieldValue('IsUpdateIMG', true);
      } else {
        formik.setFieldValue('Img', '');
        formik.setFieldValue('IsUpdateIMG', false);
      }
      return newAttachments;
    });
  };

  // console.log(formik.errors);

  // console.log(extraInfoFormData);

  return (
    <>
      <Loading
        loading={loadingById || loading2 || loading3 || loading4 || loading5}
        error={errorById || error2 || error3 || error4 || error5}
      >
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <>
              <div className='row'>
                {/* AssetNumber */}
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('AssetNumber')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='code'
                      onChange={formik.handleChange}
                      value={formik.values.code}
                      isInvalid={!!(formik.touched.code && formik.errors.code)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
                  </div>
                </div>
                {/* Model */}
                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Model')}</label>
                    <Form.Select
                      className='form-select'
                      name='fleetModelId'
                      onChange={formik.handleChange}
                      value={formik.values.fleetModelId || ''}
                      isInvalid={!!(formik.touched.fleetModelId && formik.errors.fleetModelId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {EquipmentsModelList &&
                        EquipmentsModelList?.filter(f => f.parentId !== null)?.map((item, idx) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.fleetModelId && formik.touched.fleetModelId && (
                      <div>{formik.errors.fleetModelId}</div>
                    )}
                  </div>
                </div>
                {/* Plate_Number */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Plate_Number')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='plateNo'
                      onChange={formik.handleChange}
                      value={formik.values.plateNo}
                      isInvalid={!!(formik.touched.plateNo && formik.errors.plateNo)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.plateNo}</Form.Control.Feedback>
                  </div>
                </div>
                {/* Chassis_Number */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Chassis_Number')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='chassisNo'
                      onChange={formik.handleChange}
                      value={formik.values.chassisNo}
                      isInvalid={!!(formik.touched.chassisNo && formik.errors.chassisNo)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.chassisNo}</Form.Control.Feedback>
                  </div>
                </div>

                {/* Serial_Number */}
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Serial_Number')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='serialNo'
                      onChange={formik.handleChange}
                      value={formik.values.serialNo}
                      isInvalid={!!(formik.touched.serialNo && formik.errors.serialNo)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.serialNo}</Form.Control.Feedback>
                  </div>
                </div>

                {/* Barcode */}
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Barcode')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='barcode'
                      onChange={formik.handleChange}
                      value={formik.values.barcode}
                      isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
                  </div>
                </div>

                {/* Odometer */}
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Odometer')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='odometer'
                      onChange={formik.handleChange}
                      value={formik.values.odometer}
                      isInvalid={!!(formik.touched.odometer && formik.errors.odometer)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.odometer}</Form.Control.Feedback>
                  </div>
                </div>
                {/* Owner */}
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Owner')}</label>
                    <Form.Select
                      className='form-select'
                      name='ownerId'
                      onChange={formik.handleChange}
                      value={formik.values.ownerId || ''}
                      isInvalid={!!(formik.touched.ownerId && formik.errors.ownerId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PeoplesList &&
                        PeoplesList?.filter(f => f.typeCode === 'OWNERS')?.map((item, idx) => (
                          <option key={++idx} value={item.id}>
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </option>
                        ))}
                    </Form.Select>
                  </div>
                </div>

                {/* Department */}

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Department')}</label>
                    <Select
                      classNamePrefix='react-select'
                      className='w-100   '
                      isLoading={loading4}
                      isSearchable={true}
                      isClearable
                      options={OrganizationOptions}
                      value={OrganizationOptions?.find(
                        (f: { value: string }) => f.value === formik.values.organizationId
                      )}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      onChange={(option: any) => formik.setFieldValue('organizationId', option.value)}
                      formatOptionLabel={option => (
                        <div className='d-flex justify-content-between   '>
                          <div className=''>{option.label}</div>
                          <div className=' text-muted fs-12px '>{option.locationName}</div>
                        </div>
                      )}
                      filterOption={({ label, data }, input) => {
                        const searchValue = input?.toLowerCase();
                        return (
                          label?.toLowerCase().includes(searchValue) ||
                          data.locationName?.toLowerCase().includes(searchValue)
                        );
                      }}
                    />
                  </div>
                </div>
                {/* Driver */}
                {/* <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Driver')}</label>
                    <Select
                      classNamePrefix='react-select'
                      className='w-100  '
                      isLoading={loading1}
                      isSearchable={true}
                      isClearable
                      options={OptionsDrivers}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      onChange={(option: any) => formik.setFieldValue('peopleId', option.value)}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                      }}
                      formatOptionLabel={option => (
                        <div className='d-flex justify-content-between   '>
                          <div className=''>
                            {option.hasVehicle && (
                              <i className='fas fa-car text-theme me-2' title={t('AssignedVehicle')}></i>
                            )}
                            {option.label}
                          </div>
                          <div className='text-theme fw-bold'>{option.personNo}</div>
                        </div>
                      )}
                      filterOption={({ label, data }, input) => {
                        const searchValue = input?.toLowerCase();
                        return (
                          label?.toLowerCase().includes(searchValue) ||
                          data.personNo?.toLowerCase().includes(searchValue)
                        );
                      }}
                    />
                  </div>
                </div> */}

                {/* ServiceDate */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('ServiceDate')}</label>
                    <Form.Control
                      className='form-control'
                      type='date'
                      name='serviceDate'
                      onChange={formik.handleChange}
                      value={formik.values.serviceDate}
                      isInvalid={!!(formik.touched.serviceDate && formik.errors.serviceDate)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.serviceDate}</Form.Control.Feedback>
                  </div>
                </div>
                {/* LastMaintenanceDate */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('LastMaintenanceDate')}</label>
                    <Form.Control
                      className='form-control'
                      type='date'
                      name='lastmaintenanceDate'
                      onChange={formik.handleChange}
                      value={formik.values.lastmaintenanceDate}
                      isInvalid={!!(formik.touched.lastmaintenanceDate && formik.errors.lastmaintenanceDate)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.lastmaintenanceDate}</Form.Control.Feedback>
                  </div>
                </div>
                {/* Purchase_Price */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Purchase_Price')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='purchasePrice'
                      onChange={formik.handleChange}
                      value={formik.values.purchasePrice}
                      isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.purchasePrice}</Form.Control.Feedback>
                  </div>
                </div>
                {/* Status */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Status')}</label>
                    <Select
                      classNamePrefix='react-select'
                      className='w-100   '
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      options={EquipmentStatusOptions}
                      value={EquipmentStatusOptions?.find((f: { value: string }) => f.value === formik.values.Status)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      onChange={(option: any) => formik.setFieldValue('Status', option.value)}
                    />
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Image')}</label>
                    <FileUpload attachments={img} setAttachments={handleImageUpload} multiple={false} />
                  </div>
                </div>

                {/* <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={2}
                      name='description'
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                    <div></div>
                  </div>
                </div> */}
              </div>
            </>
            <div className='rounded-2 p-3 mb-3 border border-theme'>
              <div className='d-flex align-items-center mb-3'>
                <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
                <h5 className='mb-0'>{t('ExtraInformation')}</h5>
              </div>
              {data?.extraInformationId ? (
                <ExtraInformationBuilderUpdate
                  extraInformationId={formik.values.ExtraInformationId}
                  referenceId={data?.id}
                  setExtraInfoFormData={setExtraInfoFormData}
                />
              ) : (
                <ExtraInformationBuilderAdd
                  FormColumnList={FormColumnByTableIdList}
                  setExtraInfoFormData={setExtraInfoFormData}
                  referenceId={data?.id}
                />
              )}
            </div>

            <div className='text-center'>
              <div className='d-flex justify-content-between gap-2'>
                {HasPermission('FleetEquipmentEdit') && (
                  <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
                    {formik.isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fas fa-save fa-lg fa-fw me-2'></i>
                    )}
                    {t('Save')}
                  </button>
                )}
                <button
                  type='button'
                  className='btn btn-lg  btn-default mb-1 w-100'
                  data-bs-dismiss='modal'
                  id='closeModal22'
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </Form>
        </CardBody>
      </Loading>
      {/* </Card> */}
    </>
  );
};

export default EditEquipments;

// <div className='col-xl-4'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('Image_of_Equipment')}</label>
//             <Form.Control
//               className='form-control'
//               type='file'
//               name='Img'
//               placeholder=' أختر صورة'
//               accept='image/*'
//               // onChange={(e) => handleImageUpload(e)}
//               onChange={(e: any) => {
//                 formik.setFieldValue('Img', e.currentTarget?.files[0]);
//                 formik.setFieldValue('IsUpdateIMG', true);
//               }}
//               isInvalid={!!(formik.touched.Img && formik.errors.Img)}
//             />
//             <FileList Attachments={data?.image ? [data.image] : []} />
//           </div>
//         </div>

// <div className='col-xl-4'>
//   <div className='form-group mb-3'>
//     <label className='form-label'>{t('LocalName')}</label>
//     <Form.Control
//       className='form-control'
//       type='text'
//       autoComplete='off'
//       name='name2'
//       onChange={formik.handleChange}
//       value={formik.values.name2}
//       isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//     />
//     <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//   </div>
// </div>

// <div className='col-xl-4'>
//   <div className='form-group mb-3'>
//     <label className='form-label'>{t('GlobalName')}</label>
//     <Form.Control
//       className='form-control'
//       type='text'
//       autoComplete='off'
//       name='name'
//       onChange={formik.handleChange}
//       value={formik.values.name}
//       isInvalid={!!(formik.touched.name && formik.errors.name)}
//     />
//     <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//   </div>
// </div>

// <div className='col-xl-3'>
//   <div className='form-group mb-3'>
//     <label className='form-label'>{t('dateOfExpiry')}</label>
//     <Form.Control
//       className='form-control'
//       type='date'
//       name='dateOfExpiry'
//       onChange={formik.handleChange}
//       value={formik.values.dateOfExpiry}
//       isInvalid={!!(formik.touched.dateOfExpiry && formik.errors.dateOfExpiry)}
//     />
//     <Form.Control.Feedback type='invalid'>{formik.errors.dateOfExpiry}</Form.Control.Feedback>
//   </div>
// </div>
